import { useMutation } from '@tanstack/react-query';
import { updateTodayFilterTags } from 'shared/services/backend-api';
import { ID } from 'shared/types/id';

export const useUpdateTodayFilterTagsMutation = () =>
  useMutation({
    mutationFn: async (ids: ID[]) => updateTodayFilterTags(ids),
  });
